<template>
  <v-dialog
    v-model="dialog"
    max-width="300"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :color="color"
        :icon="icon"
        depressed
        :disabled="disabled"
        :loading="loading"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        v-if="message"
        class="title text-break"
      >
        {{ message }}
      </v-card-title>

      <v-divider v-if="message" />

      <v-card-actions>
        <v-btn
          v-t="'cancel'"
          text
          @click="dialog = false"
        />

        <v-spacer />

        <v-btn
          :color="color"
          depressed
          @click="onConfirm"
        >
          {{ action }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: 'Confirm'
    },
    color: {
      type: String,
      default: 'error'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Confirm?'
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    onConfirm () {
      this.dialog = false
      this.$emit('confirm')
    }
  }
}
</script>
